import request from '@/utils/request'
import qs from 'qs'

const apis = {
    LOGOIN: '/access/login',
    VALID_CODE: '/remoteapi/getverificationsms',
    VALID_CODE_REPASSW: '/remoteapi/getVerificationSms4RetrievePassword',
    REGISTRER: '/access/register',
    MODIFY_PASSWORD: '/access/modifypassword',
    FORGET_PASSWORD: '/access/forgetpassword',
    USER_INFO: '/user/getbaseinfo',
    MODIFY_BASE_INFO: '/user/modifybaseinfo',
    VALID_CODE_IMG: '/remoteapi/getverificationcode',
    MY_PROGRESS: '/personalcenter/getmyprogress',
    INFO_DETAIL: '/specific/getmobilepersonalcenter',
    CHECK_ISSIGNUPED: '/course/checkIsSignUped',
    My_NOTICE_LIST: '/personalcenter/getmynoticelist',
    FQA_DETAIL: '/personalcenter/getfaq',
    GET_PLAT_INFO: '/personalcenter/getintro',
    My_SUGGESTION_LIST: '/personalcenter/getmysuggestionlist',
    ADD_MY_SUGGESTION: '/personalcenter/addmysuggestion',
    COMPLETE_DATA: '/personalcenter/completedata',
    GET_MY_DATA: '/personalcenter/getmydata',
    GET_CREDIT_INFO: '/personalcenter/getCreditInfo',
    GET_CREDIT_TRANS: '/personalcenter/getTransFlowByUserId',
    USER_TASK_INFO: '/personalcenter/getStudentTrainingTaskInfo',
    GET_STU_CERT_INFO: '/user/studentCertificateInfo/getStudentCertificateInfo',
    MODIFY_STU_CERT_INFO: '/user/studentCertificateInfo/modifyStudentCertificateInfo',
    SURE_FACEID_CHKDSK: '/user/studentCertificateInfo/sureFaceidChkdsk',
    GET_PC_CERT_CONFIG: '/student/peopleCategoryCertificateConfig/getPeopleCategoryCertificateConfig',
    // GET_PC_CERT_STUDENT:'/student/peopleCategoryCertificateConfig/getPcCertificateWithStudentId',
    GET_PC_CERT_LOGIN_STUDENT: '/student/peopleCategoryCertificateConfig/getPcCertificateWithLoginStudent',
    GET_PC_CERT_STUDENT: '/student/peopleCategoryCertificateConfig/getPcCertificateWithLoginStudent',
    STUDENT_PROGRESS_OVER: '/user/studentProgressOver',
    GET_STUDENT_STUDY_AGAIN_STATUS: '/user/getStudentStudyAgainStatus',
    GET_DIC_DATA_DICTYPE: '/remoteapi/getDicData4DicType',
    GET_STUDENT_DATA_APPROVE_INFO: '/user/getStudentDataApproveInfo',
    update_Jion_In_School: '/user/updateJionInSchool',
    CHECK_PHONENO: '/access/checkphonenonew',
    GET_USERMESSAGES: '/teaching/getUserMessage',
    GET_StudentOnlineCourseInfo: '/specific/getStudentOnlineCourseInfo4StudentIdByUser',
    SET_changeStudentProgresOnPhone: '/specific/changeStudentProgresOnPhone',
    SUBMIT_USER_COMMITMENT: '/user/submitUserCommitment',
    JUDGE_USER_COMMITMENT: '/user/judgeUserCommitment',
    CHECK_ISOVERLESSON: '/course/checkIsOverLesson',
    REGISTER_SETTING : 'user/registerSetting',
    CHANGE_SCHOOL:'/system/inTheSchoolRecord/inTheSchoolRequest',
    RESET_STUDY_RECORD : '/course/limitSuperRecord/studyRecordFail',
    ADD_LIMIT_SUPER_RECORD : '/course/addLimitSuperRecord',
    GET_LIMIT_SUPER_RECORD : '/course/getLimitSuperRecordCount',
    IS_CHECK_LEARNING_LIMIT_DAY : '/course/isCheckLearningLimitDay',
    GET_USER_COURSEINFO : '/user/getUserCourseInfo',
    GET_COURSELISTVO : '/studentExamRecord/courseListVo',
    GET_COURSELISTVOTWO : '/studentExamRecord/courseListVoTwo',
    COURSELISTTOO : '/courselistToo',
    //READPHOTO: '/handocr/readphoto',
    READPHOTO: '/handocr/readphoto',
    BYBASE64: '/remoteapi/uploadFileByBase64',
    GETIMAGEVERIFYCODE:'/pic/getImageVerifyCode',
    VERIFYIMAGECODE:'/pic/verifyImageCode'
}

export default {
    getImageVerifyCode(data) {
        let dt = data || {};
        return request.get(apis.GETIMAGEVERIFYCODE, dt.params, {
            headers: dt.headers || {}
        });
    },
    verifyImageCode(url) {
        let dt = "";
        return request.get(apis.VERIFYIMAGECODE+url, dt, {
            headers: dt.headers || {}
        });
    },
    //课程展示
    courseListToo(data) {
        let dt = data || {};
        return request.post(apis.COURSELISTTOO, dt.params, {
            headers: dt.headers || {}
        });
    },
    //驗證騰訊識別文字
    saveSignImg(data) {
        let dt = data || {};
        return request.post(apis.BYBASE64, dt.params, {
            headers: dt.headers || {}
        });
    },
    //保存签名图片
    readphoto(data) {
        let dt = data || {};
        return request.post(apis.READPHOTO, dt.params, {
            headers: dt.headers || {}
        });
    },
    //更换学校
    changeschool(data) {
        let dt = data || {};
        return request.post(apis.CHANGE_SCHOOL, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 获取基本信息
    getUserMessagelesson(data) {
        let dt = data || {};
        return request.post(apis.GET_USERMESSAGES, dt.params, {
            headers: dt.headers || {}
        });
    }, getStudentOnlineCourseInfo4StudentIdByUser(data) {
        let dt = data || {};
        return request.post(apis.GET_StudentOnlineCourseInfo, dt.params, {
            headers: dt.headers || {}
        });
    }, setChangeStudentProgresOnPhone(data) {
        let dt = data || {};
        return request.post(apis.SET_changeStudentProgresOnPhone, dt.params, {
            headers: dt.headers || {}
        });
    },
    getStudentDataApproveInfo(data) {
        let dt = data || {};
        return request.post(apis.GET_STUDENT_DATA_APPROVE_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },updateJionInSchool(data) {
        let dt = data || {};
        return request.post(apis.update_Jion_In_School, dt.params, {
            headers: dt.headers || {}
        });
    },
    getStudentStudyAgainStatus(data) {
        let dt = data || {};
        return request.post(apis.GET_STUDENT_STUDY_AGAIN_STATUS, dt.params, {
            headers: dt.headers || {}
        });
    },
    studentProgressOver(data) {
        let dt = data || {};
        return request.post(apis.STUDENT_PROGRESS_OVER, dt.params, {
            headers: dt.headers || {}
        });
    },
    getDicData4DicType(data) {
        let dt = data || {};
        return request.post(apis.GET_DIC_DATA_DICTYPE, dt.params, {
            headers: dt.headers || {}
        });
    },
    getPcCertificateWithStudent(data) {
        let dt = data || {};
        return request.post(apis.GET_PC_CERT_STUDENT, dt.params, {
            headers: dt.headers || {}
        });
    }, getPcCertificateWithLoginStudent(data) {
        let dt = data || {};
        return request.post(apis.GET_PC_CERT_LOGIN_STUDENT, dt.params, {
            headers: dt.headers || {}
        });
    },
    getPeopleCategoryCertificateConfig(data) {
        let dt = data || {};
        return request.post(apis.GET_PC_CERT_CONFIG, dt.params, {
            headers: dt.headers || {}
        });
    },
    modifyStudentCertificateInfo(data) {
        let dt = data || {};
        console.log(qs.stringify(dt.params));
        return request.post(apis.MODIFY_STU_CERT_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    sureFaceidChkdsk(data) {
        let dt = data || {};
        console.log(qs.stringify(dt.params));
        return request.post(apis.SURE_FACEID_CHKDSK, dt.params, {
            headers: dt.headers || {}
        });
    },
    getStudentCertificateInfo(data) {
        let dt = data || {};
        return request.post(apis.GET_STU_CERT_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 登录
    login(data) {
        let dt = data || {};
        return request.post(apis.LOGOIN, dt.params, {
            headers: dt.headers || {}
        });
    },

    // 取手机验证码
    getValidCode(data) {
        let dt = data || {};
        return request.post(apis.VALID_CODE, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 取手机验证码-找回密码
    getVerificationSms4RetrievePassword(data) {
        let dt = data || {};
        return request.post(apis.VALID_CODE_REPASSW, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 注册
    register(data) {
        let dt = data || {};
        return request.post(apis.REGISTRER, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 修改密码
    modifyPassword(data) {
        let dt = data || {};
        return request.post(apis.MODIFY_PASSWORD, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 忘记密码
    forgetPassword(data) {
        let dt = data || {};
        return request.post(apis.FORGET_PASSWORD, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 获取基本信息
    getUserInfo(data) {
        let dt = data || {};
        return request.post(apis.USER_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    getStudentTrainingTaskInfo(data) {
        let dt = data || {};
        return request.post(apis.USER_TASK_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    modifyBaseInfo(data) {
        let dt = data || {};
        let params = dt.params || {};
        let formData = new FormData();
        for (let k in params) {
            if (k && params[k] != null) {
                formData.append(k + '', params[k]);
            }
        }

        return request.post(apis.MODIFY_BASE_INFO, formData, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, dt.headers)
        });
    },

    modifyBaseInfo2(data) {
        let dt = data || {};
        return request.post(apis.MODIFY_BASE_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },

    getValidCodeImg(data) {
        let dt = data || {};
        return request.post(apis.VALID_CODE_IMG, dt.params, {
            headers: dt.headers || {}
        });
    },

    getMyProgress(data) {
        let dt = data || {};
        return request.post(apis.MY_PROGRESS, dt.params, {
            headers: dt.headers || {}
        });
    },
    resetStudyRecord(data) {
        let dt = data || {};
        return request.post(apis.RESET_STUDY_RECORD, dt.params, {
            headers: dt.headers || {}
        });
    },

    isCheckLearningLimitDay(data) {
        let dt = data || {};
        return request.post(apis.IS_CHECK_LEARNING_LIMIT_DAY, dt.params, {
            headers: dt.headers || {}
        });
    },

    getLimitSuperRecordCount(data) {
        let dt = data || {};
        return request.post(apis.GET_LIMIT_SUPER_RECORD, dt.params, {
            headers: dt.headers || {}
        });
    },

    addLimitSuperRecord(data) {
        let dt = data || {};
        return request.post(apis.ADD_LIMIT_SUPER_RECORD, dt.params, {
            headers: dt.headers || {}
        });
    },

    getInfoDetail(data) {
        let dt = data || {};
        return request.post(apis.INFO_DETAIL, dt.params, {
            headers: dt.headers || {}
        });
    },
    checkIsSignUped(data) {
        let dt = data || {};
        return request.post(apis.CHECK_ISSIGNUPED, dt.params, {
            headers: dt.headers || {}
        });
    },
    //检测课程是否完成*当状态是CONTINUE，但有无有效待学习信息时，会触发检测，检测到全部学完后会将状态设置成可以考试
    checkIsOverLesson(data) {
        let dt = data || {};
        return request.post(apis.CHECK_ISOVERLESSON, dt.params, {
            headers: dt.headers || {}
        });
    },
    getMyNoticeList(data) {
        let dt = data || {};
        return request.post(apis.My_NOTICE_LIST, dt.params, {
            headers: dt.headers || {}
        });
    },

    getFQADetail(data) {
        let dt = data || {};
        return request.post(apis.FQA_DETAIL, dt.params, {
            headers: dt.headers || {}
        });
    },

    getPlatInfo(data) {
        let dt = data || {};
        return request.post(apis.GET_PLAT_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },

    getMySuggestionList(data) {
        let dt = data || {};
        return request.post(apis.My_SUGGESTION_LIST, dt.params, {
            headers: dt.headers || {}
        });
    },

    addMySuggestion(data) {
        let dt = data || {};
        return request.post(apis.ADD_MY_SUGGESTION, dt.params, {
            headers: dt.headers || {}
        });
    },

    completeData(data) {
        let dt = data || {};
        return request.post(apis.COMPLETE_DATA, dt.params, {
            headers: dt.headers || {}
        });
    },

    getMyData(data) {
        let dt = data || {};
        return request.post(apis.GET_MY_DATA, dt.params, {
            headers: dt.headers || {}
        });
    },
    getCreditInfo(data) {
        let dt = data || {};
        return request.post(apis.GET_CREDIT_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    getCreditTrans(data) {
        let dt = data || {};
        return request.post(apis.GET_CREDIT_TRANS, dt.params, {
            headers: dt.headers || {}
        });
    },
    checkphoneno(data) {
        let dt = data || {};
        return request.post(apis.CHECK_PHONENO, dt.params, {
            headers: dt.headers || {}
        });
    },
    submitUserCommitment(data) {
        let dt = data || {};
        return request.post(apis.SUBMIT_USER_COMMITMENT, dt.params, {
            headers: dt.headers || {}
        });
    },
    judgeUserCommitment(data) {
        let dt = data || {};
        return request.post(apis.JUDGE_USER_COMMITMENT, dt.params, {
            headers: dt.headers || {}
        });
    },
    getRegisterSetting(data) {
        let dt = data || {};
        return request.post(apis.REGISTER_SETTING, dt.params, {
            headers: dt.headers || {}
        });
    },
    getUserCourseInfo(data){
        let dt = data || {};
        return request.post(apis.GET_USER_COURSEINFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    getCourseListVo(data){
        let dt = data || {};
        return request.post(apis.GET_COURSELISTVO, dt.params, {
            headers: dt.headers || {}
        });
    },
    getCourseListVoTwo(data){
        let dt = data || {};
        return request.post(apis.GET_COURSELISTVOTWO, dt.params, {
            headers: dt.headers || {}
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/user.js



// WEBPACK FOOTER //
// ./src/api/user.js